import { render, staticRenderFns } from "./TextareaInputConfig.vue?vue&type=template&id=776f5a42&scoped=true"
import script from "./TextareaInputConfig.vue?vue&type=script&lang=js"
export * from "./TextareaInputConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "776f5a42",
  null
  
)

export default component.exports